// extracted by mini-css-extract-plugin
export default {"scroll_top_main":"ScrollTop_scroll_top_main__r7Dy9","scrollIcon":"ScrollTop_scrollIcon__aW+j0"};